// https://css-loaders.com/spinner/
const Spinner = () => (
  <div
    css={{
      width: 40,
      aspectRatio: 1,
      borderRadius: "50%",
      background:
        "radial-gradient(farthest-side,#a4faff 94%,#0000) top/8px 8px no-repeat,\n    conic-gradient(#0000 30%,#a4faff)",
      mask: "radial-gradient(farthest-side,#0000 calc(100% - 8px),#000 0)",
      animation: "l13 1s infinite linear",

      "@keyframes l13": { "100%": { transform: "rotate(1turn)" } },
    }}
  ></div>
)

export default Spinner
